import React, { useState } from 'react'

const CustomSettingsSwitch = (args) => {
    
    const [status,setStatus]=useState(args.status);

    let onClick = args.onClick;

    return (
        <div className='custom-settings-switch' onClick={
            onClick !== null && onClick !== undefined ? () => {
                setStatus(!status)
                onClick()
            } : null
        }>
            <div className={status ? 'switch-active' : 'switch-deactive'}>
                {
                    status ?
                        "Attivo" :
                        "Non attivo"
                }
                {onClick !== null && onClick !== undefined ? <div className='switch-toggle'/> : null}
            </div>
        </div>
    )
}

export default CustomSettingsSwitch